<template>
  <div class="conmon-top">
    <el-row class="public-title-content">
      <el-col :span="24" style="text-align: left;">
        <el-form :inline="true" :model="formInline" class="public-content-item" label-width="70px">
          <el-form-item label="公众号：">
            <el-select v-model="formInline.original_id" placeholder="请选择" @change="selectOriginalIdAction">
              <el-option
                v-for="item in weChatOptions"
                :key="item.original_id"
                :label="item.nick_name"
                :value="item.original_id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row class="introduce-content">
      <el-col :span="24" style="text-align: left;">
        <el-form :inline="true" :model="formInline" class="public-content-item" label-width="60px">
          <el-form-item label="说明：">
            <ul>
              <li>只有发送给全部粉丝的内容才会显示在公众号历史消息</li>
              <li>每个微信粉丝在一个月内至多只能收到4条群发消息</li>
              <!--<li>分组群发时，由于后台计算处理需要时间，所以只能定时于12小时后的某一时刻进行群发</li>-->
              <!--<li>分组群发时，会在微信后台对粉丝打上一些以"CL_"开头的临时微信标签，请勿修改删除</li>-->
              <li>每天上午9:00左右更新群发数据，发送时间超过7天的图文数据不再更新</li>
            </ul>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-tabs class="border-card" @tab-click="handleChange">
      <el-tab-pane label="新建群发">
        <div class="new-send-group">
          <div class="send-group-one">
            <el-form :inline="false" :model="sendFrom" class="send-content-item" label-width="105px">
              <el-form-item label="群发对象:">
                <el-radio-group v-model="sendFrom.send_type">
                  <el-radio label="group">按群组发送</el-radio>
                  <el-radio label="all">全部粉丝</el-radio>
                </el-radio-group>
                <div class="send-object">
                  <el-select filterable v-model="sendFrom.group_id" placeholder="请选择群组" v-if="sendFrom.send_type === 'group'"
                             @visible-change="visibleChangeOne" @focus="focusWayOne" ref="selectOne">
                    <el-option
                      v-for="item in groupListArray"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </div>
              </el-form-item>
              <el-form-item label="是否定时群发:">
                <el-switch
                  v-model="isTime"
                  active-color="#13ce66"
                  inactive-color="#C2C2C2"
                  active-value="1"
                  inactive-value="0">
                </el-switch>
                <el-date-picker
                  v-if="isTime === '1'"
                  class="time-select"
                  v-model="sendFrom.start_time"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-form-item>
            </el-form>
          </div>
          <div class="send-group-two">
            <el-tabs  class="send-type" @tab-click="handleClick">
              <el-tab-pane label="图文">
                <ul class="mass-content-messages-list" v-if="picAppeare ===  true">
                  <li class="mass-content-message">
                    <div>
                      <div class="mass-content-message__updatetime" >
                        {{ displayItem.update_time }}
                      </div>
                      <div v-for="(two, index) in displayItem.content" :key="index">
                        <div class="mass-content-message__img">
                          <div class="mass-content-message__img__bg" v-if="index === 0" :style="{backgroundImage: 'url(' + two.qiniu_url + ')'}">
                          </div>
                          <div class="mass-content-message__title2" v-if="index === 0">{{ two.title }}</div>
                        </div>
                        <div class="mass-content-message-multi"  v-if="index > 0">
                          {{ two.title }}
                          <img :src="two.qiniu_url">
                        </div>
                      </div>
                    </div>
                    <div class="card-select-states" @click="modifyPic">
                      <div class="card-select-edit">修改</div>
                    </div>
                  </li>
                </ul>
                <img src="../../assets/images/tuwen.png" v-if="picAppeare ===  false" class="text-pic--uploader" @click="addTextAndPicAction">
              </el-tab-pane>
              <el-tab-pane label="文字">
                <el-form>
                  <el-form-item>
                    <div ref="editMessages" contenteditable="true" id="mytextarea"></div>
                  </el-form-item>
                </el-form>
                <div class="text-content">
                  <p><el-button class="insert-btn" @click="openInsertDialog">插入链接</el-button></p><p style="margin-top: 5px;">还可输入{{ 500-textLength }}字</p>
                </div>
              </el-tab-pane>
              <el-tab-pane label="图片">
                <el-upload
                  :headers = "header"
                  class="acivity-uploader"
                  name="pic_upload"
                  :data="{
                    'original_id': formInline.original_id
                  }"
                  :action="uploadURL"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload">
                  <img v-if="formInline.cover_img" :src="formInline.cover_img" class="acivity">
                  <img v-else src="../../assets/images/Group.png" class="default-acivity">
                  <!-- <i  class="el-icon-plus acivity-uploader-icon"></i> -->
                  <p slot="tip" class="el-upload__tip">请选择1M以下，支持上传jpg/png文件</p>
                </el-upload>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <el-row class="public-title-content">
        <el-col :span="24" style="text-align: right;">
          <el-button v-if="butsObj.group_send" style="margin-right: 60px;" type="primary"  class="second-page-btn reply-btn-type" @click="sendWechatMessageAction">群发</el-button>
          <el-button v-if="butsObj.preview" type="primary" class="second-page-btn reply-btn-type" @click="previewAction" style="background-color: #05B324;margin-right:32px!important;">预览</el-button>
        </el-col>
      </el-row>
      </el-tab-pane>
      <el-tab-pane label="群发记录">
        <el-form>
          <el-form-item v-if="recordArray.length !== 0" v-loading="loadLog">
            <div class="send-record-content" v-for="(ites, index) in recordArray" :key="index">
              <div class="send-wechat-status">
                <p>{{ ites.update_time | formatDate }}</p>
                <el-dropdown v-if="ites.status === 0" >
                  <span class="el-dropdown-link">
                    未发送
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                   <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      群发类型:
                      <span v-if="ites.type === 'image'">图片</span>
                      <span v-if="ites.type === 'news'">图文</span>
                      <span v-if="ites.type === 'text'">文本</span>
                    </el-dropdown-item>
                    <el-dropdown-item>群发对象:
                      <span v-if="ites.group_name === null">全部粉丝</span>
                      <span v-if="ites.group_name !== null">{{ ites.group_name }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="ites.type === 'image' || ites.type === 'news'">送达人数: {{ ites.target_user }}</el-dropdown-item>
                    <el-dropdown-item v-if="ites.start_time !== 0">定时时间: {{ ites.start_time | formatDate }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown v-if="ites.status === 1" >
                  <span class="el-dropdown-link">
                    发送中
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                   <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      群发类型:
                      <span v-if="ites.type === 'image'">图片</span>
                      <span v-if="ites.type === 'news'">图文</span>
                      <span v-if="ites.type === 'text'">文本</span>
                    </el-dropdown-item>
                    <el-dropdown-item>群发对象:
                      <span v-if="ites.group_name === null">全部粉丝</span>
                      <span v-if="ites.group_name !== null">{{ ites.group_name }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="ites.type === 'image' || ites.type === 'news'">送达人数: {{ ites.target_user }}</el-dropdown-item>
                    <el-dropdown-item v-if="ites.start_time !== 0">定时时间: {{ ites.start_time | formatDate }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-dropdown v-if="ites.status === 2" >
                  <span class="el-dropdown-link">
                    已结束
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                   <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                      群发类型:
                      <span v-if="ites.type === 'image'">图片</span>
                      <span v-if="ites.type === 'news'">图文</span>
                      <span v-if="ites.type === 'text'">文本</span>
                    </el-dropdown-item>
                    <el-dropdown-item>群发对象:
                      <span v-if="ites.group_name === null">全部粉丝</span>
                      <span v-if="ites.group_name !== null">{{ ites.group_name }}</span>
                    </el-dropdown-item>
                    <el-dropdown-item v-if="ites.type === 'image' || ites.type === 'news'">送达人数: {{ ites.target_user }}</el-dropdown-item>
                    <el-dropdown-item v-if="ites.start_time !== 0">定时时间: {{ ites.start_time | formatDate }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="send-wechat-content">
                <template v-if="ites.type === 'news'">
                <div class="send-wechat-item" v-for="(msg, index) in ites.message" :key="index">
                  <div class="wechat-img-content">
                    <img :src="msg.qiniu_url" class="wechat-title-img">
                  </div>
                  <div class="send-wechat-title">
                    <p class="send-wechat-title-p">{{ msg.title }}</p>
                    <div class="read-content">
                      <p>阅读:</p>
                      <p>{{ msg.int_page_read_count }}</p>
                      <p>阅读原文:</p>
                      <p>{{ msg.ori_page_read_count }}</p>
                      <p>收藏:</p>
                      <p>{{ msg.add_to_fav_count }}</p>
                      <p>转发:</p>
                      <p>{{ msg.share_count }}</p>
                    </div>
                  </div>
                </div>
                </template>
                <template v-if="ites.type === 'image'">
                <div
                  class="send-wechat-item"
                  v-for="(msg, index) in ites.message"
                  :key="index">
                  <div class="wechat-img-content">
                    <img :src="msg.qiniu_url" class="wechat-title-img">
                  </div>
                  <div class="send-wechat-title">
                    <p class="send-wechat-title-p">{{ msg.title }}</p>
                    <div class="read-content">
                      <p>阅读:</p>
                      <p>{{ msg.int_page_read_count }}</p>
                      <p>阅读原文:</p>
                      <p>{{ msg.ori_page_read_count }}</p>
                      <p>收藏:</p>
                      <p>{{ msg.add_to_fav_count }}</p>
                      <p>转发:</p>
                      <p>{{ msg.share_count }}</p>
                    </div>
                  </div>
                </div>
                </template>
                <div class="send-wechat-item" v-if="ites.type === 'text'">
                  <div class="wechat-img-content">
                    <img src="../../assets/images/send-default-img.png" class="wechat-title-img">
                  </div>
                  <div class="send-wechat-title">
                    <p class="send-wechat-title-p">{{ ites.text }}</p>
                    <div class="read-content">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="table-foot">
          <el-pagination
            class="table-foot-pagination"
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="limit"
            layout="total, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog class="cellDialog" title="插入链接" :visible.sync="insertDialog" width="400px">
      <el-form label-width="50px" :inline="true">
        <el-form-item label="文本">
          <el-input v-model="text"></el-input>
        </el-form-item>
        <el-form-item label="链接">
          <el-input v-model="urlLink"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="insertDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmInsert">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="cellDialog" title="选择图文" :visible.sync="picAndTextDialog" width="870px">
      <el-form label-width="50px" :inline="true">
        <el-button style="margin-left: 70%;" type="primary">系统自动同步最近10条图文素材</el-button>
        <ul class="mass-content-messages-list">
          <li class="mass-content-message" v-for="(item, index) in materialArray" :key="index">
            <div>
              <div class="mass-content-message__updatetime">
                {{ item.update_time }}
              </div>
              <div v-for="(items, index) in item.content" :key="index">
                <div class="mass-content-message__img">
                  <div class="mass-content-message__img__bg" v-if="index === 0" :style="{backgroundImage: 'url(' + items.qiniu_url + ')'}">
                  </div>
                  <div class="mass-content-message__title2" v-if="index === 0">{{ items.title }}</div>
                </div>
                <div class="mass-content-message-multi"  v-if="index > 0">
                  {{ items.title }}
                  <img :src="items.qiniu_url">
                </div>
              </div>
            </div>
            <div class="mass-content-message--selected">
              <img src="../../assets/images/gou.png" class="gou-img">
            </div>
            <div class="card-select-state" @click="selectTextAndPicAction(index, item)">
              <div class="card-select-edit">选择</div>
            </div>
          </li>
        </ul>
        <div class="table-foot">
      </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="picAndTextDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="confirmMaterial">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog class="cellDialog" title="发送预览" :visible.sync="previewDialog" width="400px">
      <p class="left-msg-num" style="color:#333;">
        今日剩余可预览消息数：
        <span style="color:#1980FF">{{ msgNum }}</span>
      </p>
      <el-form label-width="0px" :inline="true" ref="formInline" :model="formInline" :rules="rules">
        <p class="public-number" style="text-align: left">公众号：{{ publicList[formInline.original_id] }}</p>
        <el-form-item prop="wxname">
          <el-input class="input-public-num" v-model="formInline.wxname" placeholder="请输入微信号"></el-input>
        </el-form-item>
        <p class="public-number-tip">*图文消息的预览链接会在短期内失效</p>
        <p class="public-number-tip">*关注该公众号后，才能接收消息预览</p>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="dialog-cancel-btn" @click="previewDialog = false" style="margin-left: 20px">取 消</el-button>
        <el-button class="dialog-confirm-btn" type="primary" style="margin-right: 32px" @click="submitForm('formInline')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { API_HOST } from '@/api/local'
import { getSourceMaterialList, wechatGroupPreview, getWechatSendGroupRecord, getWechatPublicListForNode, sendWechatMessage, getGroupList, getleftPreviewCount } from '@/api/customer.js'
import { getAudGroupList } from '@/api/set.js'
import cursorPosition from '@/assets/js/cursor-position.js'
import { butonsList, getMenId } from '@/api/analyse.js'
export default {
  name: 'wechatSendGroup',
  data () {
    return {
      butsObj: { // button按钮列表
        preview: false,
        group_send: false
      },
      inputFlagOne: null,
      modelId: '',
      loadLog: true,
      msgNum: 97,
      picAndTextDialog: false,
      text: '',
      totalCount: 0,
      page: 1,
      limit: 10,
      urlLink: '',
      insertDialog: false,
      loading: false,
      isTime: '0',
      weChatOptions: [],
      sendFrom: {
        original_id: '',
        type: '',
        send_type: 'group',
        media_id: '',
        text: '',
        openids: '',
        start_time: ''
      },
      formInline: {
        cover_img: '',
        original_id: '', // 公众号原始id
        wxname: '', // 用户的openid
        type: 'news', // 发送消息的类型 image:图片 news:图文 text:文本
        media_id: '', // 当type不为text时必填，素材id
        text: '' // 当type为text时必填，文本内容
      },
      publicList: {},
      position: {},
      range: Object,
      sel: Object,
      picAppeare: false,
      materialArray: [],
      previewDialog: false,
      displayItem: {},
      groupListArray: [],
      header: {
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId')
      },
      recordArray: [],
      textLength: 0,
      selectItem: [],
      rules: {
        wxname: [
          { required: true, message: '请输入微信号', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    let element = this.$refs.editMessages
    let _this = this
    element.addEventListener('DOMSubtreeModified', function(e) {
      if (e.srcElement.textContent.length > 500) {
        element.innerHTML = element.innerHTML.substr(0, 500)
        element.blur()
      }
      _this.textLength = e.srcElement.textContent.length
    }, false)
    this.getButtonsList()
  },
  methods: {
    focusWayOne () {
      if (this.inputFlagOne) {
        this.$refs['selectOne'].blur()
      }
    },
    visibleChangeOne (val) {
      setTimeout(()=> {
        this.inputFlagOne = val
      },0)
    },
    // 获取可用菜单按钮列表
    getButtonsList () {
      let params = {
        systemCode: 'ZY_INTELLIQUOR',
        authKey: Lockr.get('authKey'),
        sessionId: Lockr.get('sessionId'),
        menuId: getMenId(this.$route.path)
      }
      butonsList(params).then(res=>{
        if (res.data.code === '200') {
          let result = res.data.result || []
          let arrObj = Object.keys(this.butsObj)
          let newarr  = result.map((item)=>{
            return item.perms
          })
          arrObj.map(it=> {
            if (newarr.indexOf(it)!==-1) {
              this.butsObj[it] = true
            } else {
              this.butsObj[it] = false
            }
          })
        }
      }).catch(err=>{
        this.$message.error(err)
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.confirmPreviewAction()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleChange(tab, event) {
      this.getSendRecordList()
    },
    getLeftMsgCount() {
      getleftPreviewCount(this.formInline.original_id).then(res => {
        this.msgNum = res.data.data.count
      })
    },
    // 群发消息
    sendWechatMessageAction() {
      let element = this.$refs.editMessages
      this.formInline.text = element.innerHTML
      this.sendFrom.original_id = this.formInline.original_id
      this.sendFrom.text = this.formInline.text
      this.sendFrom.media_id = this.formInline.media_id
      this.sendFrom.type = this.formInline.type
      sendWechatMessage(this.sendFrom).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
        }
      })
    },
    confirmPreviewAction() {
      let element = this.$refs.editMessages
      this.formInline.text = element.innerHTML
      wechatGroupPreview(this.formInline).then(res => {
        if (res.data.code === 0) {
          _g.toastMsg('success', res.data.error)
          this.previewDialog = false
          this.formInline.wxname = ''
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    handleClick(tab, event) {
      this.formInline.media_id = ''
      this.formInline.text = ''
      this.formInline.cover_img = ''
      if (tab.index === '0') {
        this.formInline.type = 'news'
      } else if (tab.index === '1') {
        this.formInline.type = 'text'
      } else if (tab.index === '2') {
        this.formInline.type = 'image'
      }
    },
    // 更换公众号
    selectOriginalIdAction(val) {
      this.sendFrom = {
        original_id: '',
        type: '',
        send_type: 'group',
        media_id: '',
        text: '',
        openids: '',
        start_time: ''
      }
      this.$refs.editMessages.innerHTML = ''
      this.formInline.cover_img = ''
      this.position = {}
      this.range = Object
      this.sel = Object
      this.picAppeare = false,
      this.materialArray = [],
      this.previewDialog = false,
      this.displayItem = {}
      this.groupListArray = []

      for (let one of this.weChatOptions) {
        if (val === one.original_id) {
          this.modelId = one.model_id
          break
        }
      }
      this.getSendRecordList()
      this.getMatrialList()
      this.loadGroup(this.modelId)
    },
    // 发送记录
    getSendRecordList() {
      this.loadLog = true
      getWechatSendGroupRecord(this.formInline.original_id, this.page, this.limit).then(res => {
        this.recordArray = res.data.data.list
        this.totalCount = res.data.data.total
      })
      this.openLoading()
    },
    // 数据加载时的动画
    openLoading() {
      setTimeout(() => {
        this.loadLog = false
      }, 500)
    },
    // 弹出预览
    previewAction() {
      if (this.formInline.original_id === '') {
        _g.toastMsg('error', '请选择微信公众号')
        return
      }
      this.previewDialog = true
      this.getLeftMsgCount()
    },
    // 修改素材
    modifyPic() {
      this.picAndTextDialog = true
      let classLength1 = document.getElementsByClassName('mass-content-message--selected')
      for (let item of classLength1) {
        item.style.display = 'none'
      }
    },
    confirmMaterial() {
      this.formInline.media_id = this.selectItem.media_id
      this.displayItem = this.selectItem
      this.picAppeare = true
      this.picAndTextDialog = false
    },
    selectTextAndPicAction(index, it) {
      this.selectItem = it
      let classLength1 = document.getElementsByClassName('mass-content-message--selected')
      for (let item of classLength1) {
        item.style.display = 'none'
      }
      document.getElementsByClassName('mass-content-message--selected')[index].style.display = 'block'
    },
    addTextAndPicAction() {
      if (this.formInline.original_id === '') {
        _g.toastMsg('error', '请选择微信公众号')
        return
      }
      this.picAndTextDialog = true
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getSendRecordList()
    },
    handleCurrentChange(page) {
      this.page = page
      this.getSendRecordList()
    },
    confirmInsert() {
      let reg = new RegExp('(ftp|http|https):\\/\\/(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&amp;%@!\\-\\/]))?')
      if (!reg.test(this.urlLink)) {
        _g.toastMsg('error', '请以http://或者https://开头输入网址')
        return
      }
      if (this.text === '') {
        _g.toastMsg('error', '请填入插入文本')
        return
      }
      if (this.sel.getRangeAt || this.sel.rangeCount) {
        let el = document.createElement('a')
        el.innerHTML = this.text
        el.setAttribute('href', this.urlLink)
        let frag = document.createDocumentFragment()
        let node = el.firstChild
        let lastNode
        lastNode = frag.appendChild(el)
        this.range.insertNode(frag)
        if (lastNode) {
          this.range = this.range.cloneRange()
          this.range.setStartAfter(lastNode)
          this.range.collapse(true)
          this.sel.removeAllRanges()
          this.sel.addRange(this.range)
        }
      } else if (document.selection && document.selection.type !== 'Control') {
        document.selection.createRange().pasteHTML(html)
      }
      this.insertDialog = false
      this.urlLink = ''
      this.text = ''
    },
    insertUrlAction() {
      this.insertDialog = true
    },
    // 图片上传之前
    beforeAvatarUpload(file) {
      if (this.formInline.original_id === '') {
        _g.toastMsg('error', '请选择微信公众号')
        return false
      }
      _g.toastMsg('success', '正在上传')
      this.loading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt1M = file.size / 1024 / 1024 < 1
      if (!isJPG && !isPNG) {
        _g.toastMsg('error', '上传头像图片只能是 JPG/PNG 格式!')
        this.loading = false
      }
      if (!isLt1M) {
        _g.toastMsg('error', '上传头像图片大小不能超过 1MB!')
        this.loading = false
      }
      return (isJPG && isLt1M) || (isPNG && isLt1M)
    },
    // 图片上传成功
    handleAvatarSuccess(res, file) {
      if (res.code === 0) {
        _g.toastMsg('success', '上传成功')
      } else {
        _g.toastMsg('error', res.error)
      }
      this.loading = false
      this.formInline.cover_img = res.data.qiniu_url
      this.formInline.media_id = res.data.media_id
    },
    // 插入链接弹窗打开
    openInsertDialog() {
      this.insertDialog = true
      let element = this.$refs.editMessages
      if (window.getSelection) {
        this.sel = window.getSelection()
        this.range = this.sel.getRangeAt(0)
        this.range.deleteContents()
      }
    },
    // 微信公众号列表
    loadWechatList() {
      getWechatPublicListForNode('1').then(res => {
        this.weChatOptions = res.data.data.list
        for (let one of res.data.data.list) {
          this.publicList[one.original_id] = one.nick_name
          if (one.is_default === 1) {
            this.formInline.original_id = one.original_id
            this.modelId = one.model_id
            console.log('10', this.modelId)
          }
        }
        this.getSendRecordList()
        this.getMatrialList()
        this.loadGroup(this.modelId)
      })
    },
    // 获取素材列表
    getMatrialList() {
      getSourceMaterialList(this.formInline.original_id).then(res => {
        this.materialArray = res.data.data.list[0].item
      })
    },
    // 加载群组列表
    loadGroup(modelId) {
      this.loading = true
      getAudGroupList(modelId, 1, 10000, '', '').then((res) => {
        if (res.data.code == 200) {
          this.groupListArray = res.data.result.list
        }
      })
    },
  },
  computed: {
    uploadURL() {
      return API_HOST + 'wechat/material/uploadPic'
    }
  },
  created() {
    this.loadWechatList()
  }
}
</script>

<style scoped>
.conmon-top {
  padding: 20px;
}
.public-title-content {
  background: #fff;
  height: 60px;
  padding: 10px;
  line-height: 40px;
}
.public-content-item {
  padding-left:22px;
  text-align: left;
}
.send-content-item {
  padding-left:20px;
  text-align: left;
  margin-top: 20px;
}
.introduce-content {
  margin-top: 20px;
  background: #fff;
  border: 1px solid #ebebeb;
  padding: 10px;
}
.introduce-content ul {
  padding-left: 20px;
}
.introduce-content li {
  height: 25px;
  font-size: 14px;
  color: #999;
}
.border-card {
  padding-left: 20px;
  margin-top: 10px;
  background-color: #fff;
}
.new-send-group {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.send-group-one {
  width: 57.5%;
  border: 1px solid #dedede;
}
.send-group-two {
  margin-left: 10px;
  width: 37.5%;
  border: 1px solid #dedede;
}
.send-object {
  margin-top: 15px;
}
.acivity-uploader {
  margin-top: 20px;
}
.acivity-uploader .el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.acivity-uploader .el-upload:hover {
  border-color: #409EFF;
}
.acivity-uploader-icon {
  border: 1px dashed #d9d9d9;
  font-size: 28px;
  color: #8c939d;
  width: 208px;
  height: 208px;
  line-height: 208px;
  text-align: center;
}
.acivity {
  width: 208px;
  display: block;
}
.default-acivity {
  width: 108px;
  display: block;
}
.text-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-top: -25px;
}
.text-content p {
  width: 50%;
}
.text-content button {
  float: left;
}
.text-content p:first-child {
  text-align: left;
  color: #5193FC;
  font-size: 14px;
  margin-top: 0px;
}
.text-content p:nth-child(2) {
  text-align: right;
  font-size: 14px;
}
#mytextarea{
  border: 1px solid #c0c4cc;
  border-radius: 4px;
  line-height: 24px;
  padding: 0 5px;
  text-align: left;
  height: 150px;
  overflow-y: auto;
  width: 95%;
  outline: none;
}
.send-record-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  border-bottom: 1px solid #dedede;
}
.send-wechat-status {
  width: 15%;
  height: 100px;
}
.send-wechat-content {
  width: 80%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.send-wechat-item {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  margin-right: 20px;
}
.wechat-img-content {
  width: 30%
}
.wechat-title-img {
  width: 150px;
  margin-top: 20px;
  margin-bottom: 10px;
  height: 100px;
}
.send-wechat-title {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-left: 20px;
  width: 70%;
  margin-top: 20px;
}
.read-content {
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
}
.read-content p:nth-child(2n+1){
  color: #666;
  margin-right: 5px;
  margin-top: 0px;
}
.read-content p:nth-child(2n){
  color: #999;
  margin-right: 15px;
  margin-top: 0px;
}
.send-wechat-title-p {
  text-align: left;
  margin-bottom: 0px;
  font-weight: 500;
}
.mass-content-message {
  border: 1px solid #ddd;
  padding: 8px 8px 12px 8px;
  width: 300px;
  height: 100%;
  margin: 10px;
  position: relative;
  overflow-y: hidden;
  overflow-x: hidden;
}
.mass-content-message:hover .card-select-states {
  opacity: 1;
}
.mass-content-message:hover .card-select-state {
  opacity: 1 !important;
}
.mass-content-messages-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 70px;
  min-height: 300px;
  margin-top: 24px;
  list-style: none;
  height: 400px;
  overflow-y: auto;
}
.mass-content-message__updatetime {
  padding-bottom: 8px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 8px;
}
.mass-content-message__title {
  margin-top: 8px;
  margin-bottom: 6px;
  color: #777;
}
.mass-content-message__img {
  position: relative;
}
.mass-content-message__img__bg {
  height: 165px;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.mass-content-message__img img {
  width: 100%;
  border-style: none
}
.mass-content-message__img .mass-content-message__title2 {
  position: absolute;
  bottom: 0;
  padding: 5px;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  width: 100%;
}
.mass-content-message__digest {
  margin-top: 6px;
  color: #999;
}
.mass-content-message-multi {
  padding: 8px 0 0;
  margin-top: 8px;
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
}
.mass-content-message-multi img {
  width: 48px;
  height: 48px;
}
.card-select-state {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  opacity: 0;
  cursor: pointer;
}
.card-select-states {
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  justify-content: center;
  align-items: center;
  display: flex;
  opacity: 0;
  cursor: pointer;
}
.card-select-edit {
  font-size: 18px;
  color: white;
}
.left-msg-num {
  text-align: left;
  font-size: 14px;
  margin-top: 0px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.public-number {
  text-align: left;
  color: #333;
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 10px;
  margin-left: 10px;
}
.public-number-tip {
  margin-top: 0px;
  color: #999;
}
.send-type {
  padding: 10px 20px 20px 20px;
  margin-bottom: 20px;
}
.mass-content-message--selected {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
}
.gou-img {
  display: inline-block;
  margin: 40% auto;
  width: 60px;
  height: 60px;
}
.time-select {
  width: 192px;
  margin-left: 8px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.el-upload__tip {
  text-align: center;
  width: 100%;
}
.input-public-num {
  width: 242px;
}
.send-wechat-text {
  margin-left: 40px;
  text-align: left;
  height: 100px;
  line-height: 100px;
}
.text-pic--uploader {
  margin-top: 20px;
  width: 108px;
  height: 108px;
}
.insert-btn {
  margin-top: 10px;
  width: 90px;
  height: 30px;
  border-radius: 4px;
  background: #fff;
  color: #333;
  border: 1px solid #E7E7E7;
}
</style>
